export default function () {
	'use strict';

	let x = 22;

	document.querySelectorAll('.tab-btn').forEach(button => {
		button.addEventListener('click', () => {
			const sidebar = button.parentElement;
			const tabs = sidebar.parentElement;
			const tabNumber = button.dataset.forTab;
			const tabActivate = tabs.querySelector(`.tab-content[data-tab="${tabNumber}"]`);

			// Remove the active state from previous tabs and contents.
			sidebar.querySelectorAll('.tab-btn').forEach(btn => btn.classList.remove('tab-btn-active'));
			tabs.querySelectorAll('.tab-content').forEach(tab => tab.classList.remove('tab-content-active'));

			// Set the current tab button and the content to active.
			button.classList.add('tab-btn-active');
			tabActivate.classList.add('tab-content-active');

			// Show the first x elements in the active tab.
			const items = $('#buttons-icons-person-card.tab-content-active .col-wrap .col-4');
			items.slice(0, x).css('display', 'block'); // Show the first x items

			const size = items.length;

			// Toggle the visibility of the "Load More" button.
			const loadMoreButton = $('#buttons-icons-person-card.tab-content-active #loadmore');
			if (x >= size) {
				loadMoreButton.hide();
			} else {
				loadMoreButton.show();
			}

			// Set up the "Load More" functionality.
			loadMoreButton.off('click').on('click', function () {
				x = Math.min(x + 24, size); // Increase x but not beyond size
				items.slice(0, x).css('display', 'block');

				if (x >= size) {
					loadMoreButton.hide();
				}
			});
		});
	});

	// Display the initial default tab (Board of Directors) people
	setTimeout(function () {
		const items = $('#buttons-icons-person-card.tab-content-active .col-wrap .col-4');
		items.slice(0, x).css('display', 'block'); // Show the first x items

		const size = items.length;

		// Toggle the visibility of the "Load More" button.
		const loadMoreButton = $('#buttons-icons-person-card.tab-content-active #loadmore');
		if (x >= size) {
			loadMoreButton.hide();
		} else {
			loadMoreButton.show();
		}
	}, 1500); // 1.5s
}
